import muiMakeStyles from '@mui/styles/makeStyles'
import { theme } from './theme'

const makeStyles = ((styles: unknown, options: Record<string, unknown> = {}) =>
  muiMakeStyles(styles as never, { defaultTheme: theme, ...options })) as typeof muiMakeStyles

export default makeStyles
